const theme = {
    colors: {
        primary: '#137cbd',
        primaryLight: 'lightskyblue'
    }
}

export default theme